var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-sm btn-primary pl-4 pr-4",on:{"click":function($event){$event.preventDefault();return _vm.clickVerifyBtn()}}},[_vm._v(" "+_vm._s(_vm.$t('profile.label.verify.authenticator'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }